import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_cart_5: FaireProductEntity = {
  token: "atc_fs_cart_5",
  type: "product",
  name: "Power Mist Coconut",
  brandName: "West Clay Company",
  brandToken: "west-clay-company",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c27a4d1c220729290822c4da0f11afc7ca89a97f830d7010e62e8fe1c040ed47.webp",
  priceDollars: 10,
  msrpDollars: 20,
  description: "ATC cart product seed",
  tags: ["beauty", "atc", "cart"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
